// ES tree = EN spec tree minus rows with no ES page, plus the ES-only rows from
// today's desktop dropdowns (decisions 17, 18). Labels and hrefs reuse the
// existing ES dropdown data; dropped: Business Solutions, Nonprofit Salary
// Explorer, Volunteer Engagement Resources.
import { I18nLocale } from '#/i18n/types/I18nLocale';
import { IDEALIST_DAYS_PATH } from '#/layouts/Layout/Header/layoutHeaderConstants';
import { searchGetEventsPath } from '#/modules/search/events/routing/searchGetEventsPath';
import { searchGetInternshipsPath } from '#/modules/search/internships/routing/searchGetInternshipsPath';
import { searchGetJobsPath } from '#/modules/search/jobs/routing/searchGetJobsPath';
import { searchGetOrgsPath } from '#/modules/search/orgs/routing/searchGetOrgsPath';
import { searchGetVolopsPath } from '#/modules/search/volops/routing/searchGetVolopsPath';
import { userDashboardCreateEventPath } from '#/modules/userDashboard/routing/userDashboard.paths';
import { SIGN_UP_TO_POST_URL_FOR_LOCALE } from '#/routing/route-constants';
import { createOrgPath, postAListingPath } from '#/routing/routes';

import type { HamburgerMenuData } from './types/HamburgerMenuData';

// CREATE rows with loggedOutHref point to SIGN_UP_TO_POST_URL_FOR_LOCALE when
// there is no user; href is the logged-in target.
export const hamburgerMenuDataEs: HamburgerMenuData = {
  sections: [
    {
      type: 'explore',
      title: 'Explora',
      rows: [
        {
          type: 'get-involved',
          title: 'Participa',
          href: IDEALIST_DAYS_PATH[I18nLocale.ES],
        },
        {
          type: 'job',
          title: 'Empleos',
          href: searchGetJobsPath({
            locale: I18nLocale.ES,
            embedSearchWidgetId: null,
          }),
        },
        {
          type: 'volop',
          title: 'Voluntariado',
          href: searchGetVolopsPath({
            locale: I18nLocale.ES,
            embedSearchWidgetId: null,
          }),
        },
        {
          type: 'internship',
          title: 'Pasantías',
          href: searchGetInternshipsPath({ locale: I18nLocale.ES }),
        },
        {
          type: 'org',
          title: 'Organizaciones',
          href: searchGetOrgsPath({ locale: I18nLocale.ES }),
        },
        {
          type: 'events',
          title: 'Buscar Eventos',
          href: searchGetEventsPath({ locale: I18nLocale.ES }),
        },
        {
          type: 'resources',
          title: 'Recursos',
          rows: [
            {
              type: 'career-advice',
              title: 'Desarrollo de carrera',
              href: '/es/accion?categories=empleocambiamundo&pq=',
            },
            {
              type: 'volunteer-resources',
              title: 'Blog Idealistas / Voluntariado',
              href: '/es/accion?categories=voluntariado&pq=',
            },
            {
              type: 'blog',
              title: 'Blog Idealistas',
              href: '/es/accion?pq=',
            },
            {
              type: 'recipes-for-action',
              title: 'Recetas para la Acción',
              href: '/es/recetas-para-accion',
            },
            {
              type: 'employer-resources',
              title: 'Herramientas para Reclutadores',
              href: '/es/orgs/encuentra-talento',
            },
            {
              type: 'fundraising-resources',
              title: 'Recursos para Recaudar Fondos',
              href: '/es/recursos-recaudacion-fondos',
            },
          ],
        },
      ],
    },
    {
      type: 'create',
      title: 'Publica',
      rows: [
        {
          type: 'post-a-listing',
          title: 'Publica una Oportunidad',
          href: postAListingPath.with({}),
          loggedOutHref: SIGN_UP_TO_POST_URL_FOR_LOCALE.es,
        },
        {
          type: 'post-an-event',
          title: 'Publicar un Evento',
          href: userDashboardCreateEventPath.with({}),
          adminUserHref: postAListingPath.with({ listingType: 'EVENT' }),
        },
        {
          type: 'create-org',
          title: 'Suma tu Organización',
          href: createOrgPath.with({}),
          loggedOutHref: SIGN_UP_TO_POST_URL_FOR_LOCALE.es,
        },
      ],
    },
  ],
  accountSectionTitle: 'Cuenta',
  myAccountSectionTitle: 'Mi cuenta',
  organizationSectionTitle: 'Organización',
  organizationsSectionTitle: 'Organizaciones',
};
